import { Reducer } from '@reduxjs/toolkit'
import { STATUS, StatusValue } from '../../../Common/Utils'
import { GET_ACTIVE_EVALUATION_FORMS } from './evaluationForm.constants'
import { EvalFormAction } from './evaluationForm.actions'
import { EvalForm } from './evaluationForm.api'

interface EvalFormState {
  activeForms: {
    status: StatusValue,
    error: unknown,
    data: EvalForm[],
  },
}

const initialState = {
  activeForms: {
    status: STATUS.IDLE,
    error: false,
    data: [],
  },
}

const evalFormReducer: Reducer<EvalFormState, EvalFormAction> = (state = initialState, action) => {
  const reducers = {
    [GET_ACTIVE_EVALUATION_FORMS.REQUESTED]: (state: EvalFormState) => ({
      ...state,
      activeForms: {
        ...state.activeForms,
        status: STATUS.PENDING,
      },
    }),
    [GET_ACTIVE_EVALUATION_FORMS.SUCCESS]: (state: EvalFormState, action: Extract<EvalFormAction, { type: 'EVALUATION_FORM_GET_ACTIVE_EVALUATION_FORMS_SUCCESS' }>) => ({
      ...state,
      activeForms: {
        data: action.response,
        error: null,
        status: STATUS.RESOLVED,
      },
    }),
    [GET_ACTIVE_EVALUATION_FORMS.FAILURE]: (state: EvalFormState, action: Extract<EvalFormAction, { type: 'EVALUATION_FORM_GET_ACTIVE_EVALUATION_FORMS_FAILURE' }>) => ({
      ...state,
      activeForms: {
        data: [],
        error: action.error,
        status: STATUS.REJECTED,
      },
    }),
  }
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: migrate to RTK Query or react-query
  return reducers[action.type] ? reducers[action.type](state, action as $TSFIXME) : state
}

export default evalFormReducer
